import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import TransfusionComponentsStep2Part1 from "./transfusion-components-step2-parts/transfusion-components-step2-part1";

export default class TransfusionComponentsStep2Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: TransfusionComponentsStep2ComponentMainConfig) {
		let context = this;
		context._parts.push(new TransfusionComponentsStep2Part1(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface TransfusionComponentsStep2ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: TransfusionComponentsStep2ComponentPart1Config;
	onDone: () => void;
}

export interface TransfusionComponentsStep2ComponentPart1Config extends GeneralPartConfig {
}